import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-site-advert-author',
	templateUrl: './site-advert-author.component.html',
	styleUrls: ['./site-advert-author.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SiteAdvertAuthorComponent {
	@Input() logo: string;

	@Input() content: string;

	@Input() path: string;

	@Output() stepChange = new EventEmitter();

	constructor() {
	}
}
